import React, { ErrorInfo } from "react"
import DefaultError from "../pages/error"

export class ErrorBoundary extends React.Component<any, any> {
  state: {
    hasError: boolean
    error?: Error
  }

  constructor(props: any) {
    super(props)

    // to keep track of when an error occurs
    // and the error itself
    this.state = {
      hasError: false,
      error: undefined
    }
  }

  // update the component state when an error occurs
  static getDerivedStateFromError(error: Error) {
    // specify that the error boundary has caught an error
    return {
      hasError: true,
      error: error
    }
  }

  // Log the error
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.log("===Error caught!===")
    console.error(error)
    console.error(errorInfo)
    console.log("==================")
  }

  render() {
    return this.state.hasError ? (
      <DefaultError error={this.state.error || new Error("unknown error")} />
    ) : (
      this.props.children
    )
  }
}
